/* =================== SERVIÇOS HOME =================== */
$(function () {
  $('.carrosel-equipe').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 760,
        settings: 'unslick',
      },
    ],
  });
});
